import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormStatus } from '@modeso/aumico-lib-core-fe';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IRegistrationFormValue } from '../../interfaces/registration-form-value.interface';
import { IRegistration } from '../../interfaces/registration.interface';
import { localizationKeys } from './../../constants/localizationKeys';

@UntilDestroy()
@Component({
    selector: 'aumico-users-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent implements OnInit {
    form: UntypedFormGroup;
    localizations = localizationKeys;
    private isFormValid = false;

    @Input() countries: INameId[] = [];

    @Output() registrationData = new EventEmitter<IRegistration>();
    @Output() registrationFormStatus = new EventEmitter<boolean>();
    @Output() pricesClicked = new EventEmitter<void>();
    @Output() termsAndConditionsClicked = new EventEmitter<void>();
    @Output() privacyPolicyClicked = new EventEmitter<void>();
    @Output() agreementOnOrderDataProcessingClicked = new EventEmitter<void>();

    constructor(
        private formBuilder: UntypedFormBuilder,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
    ) {
        this.form = this.formBuilder.group({
            org: [null, { validators: [Validators.required] }],
            firstName: [null, { validators: [Validators.required] }],
            lastName: [null, { validators: [Validators.required] }],
            email: [null, { validators: [Validators.required, Validators.email] }],
            country: [null, { validators: [Validators.required] }],
            acceptPolicy: [true, { validators: [Validators.requiredTrue] }],
            subscribeMarketing: [false],
        });

        this.addSvgIcon('aumico-pattern-icon-alert-info');
    }

    ngOnInit(): void {
        this.form.statusChanges.pipe(untilDestroyed(this)).subscribe((status) => {
            this.isFormValid = status === FormStatus.VALID;
            this.emitRegistrationData();
        });
    }

    public openPricesLink(): void {
        this.pricesClicked.emit();
    }

    public openTermsAndConditionsLink(): void {
        this.termsAndConditionsClicked.emit();
    }

    public openPrivacyPolicyLink(): void {
        this.privacyPolicyClicked.emit();
    }

    public openAgreementOnOrderDataProcessingLink(): void {
        this.agreementOnOrderDataProcessingClicked.emit();
    }

    private emitRegistrationData(): void {
        this.registrationFormStatus.emit(this.isFormValid);
        if (this.isFormValid) {
            const regFormValue = this.form.getRawValue() as IRegistrationFormValue;
            const registrationOutputData: IRegistration = {
                ...regFormValue,
                country: regFormValue.country.id,
            };
            this.registrationData.emit(registrationOutputData);
        }
    }

    private addSvgIcon(name: string) {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
